import { useEffect, useRef } from 'react';
import { onSessionChange } from '../stores/session-read';

/**
 * A modal opened on behalf of one session closes when the session changes
 * (#940 r8). Tip, withdraw, purchase, cancel, delete-account and edit-profile
 * all hold in-flight work for the account that opened them; after a sign-out
 * or a switch, that work's answer is 'ended' and the modal has nothing left to
 * show the next account. Registers only while `active` (the modal is open).
 */
export function useDismissOnSessionChange(active: boolean, dismiss: () => void): void {
  const dismissRef = useRef(dismiss);
  dismissRef.current = dismiss;
  useEffect(() => {
    if (!active) return;
    return onSessionChange(() => dismissRef.current());
  }, [active]);
}
